import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard",
    path: `${APP_PREFIX_PATH}/Assessments`,
    component: React.lazy(() => import("views/app-views/Assessments")),
  },
  {
    key: "addNew",
    path: `${APP_PREFIX_PATH}/AddNew`,
    component: React.lazy(() => import("views/app-views/AddNew/AddNew")),
  },
  {
    key: "edit",
    path: `${APP_PREFIX_PATH}/EditInspection/:id`,
    component: React.lazy(() => import("views/app-views/AddNew/AddNew")),
  },
  {
    key: "users",
    path: `${APP_PREFIX_PATH}/Users`,
    component: React.lazy(() => import("views/app-views/Users/Users")),
  },
  // {
  //   key: "permissions",
  //   path: `${APP_PREFIX_PATH}/Permissions`,
  //   component: React.lazy(() =>
  //     import("views/app-views/Permissions/Permissions")
  //   ),
  // },
  {
    key: "report",
    path: `${APP_PREFIX_PATH}/Report`,
    component: React.lazy(() =>
      import("views/app-views/ReportList/ReportList")
    ),
  },
  {
    key: "change-password",
    path: `${AUTH_PREFIX_PATH}/change-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/change-password")
    ),
  },
];
